const jiemai = (id) => {
    let arr = ['61c41a456fe345b29eddc6fc','61c417036fe345b29eddc65b','61c40a136fe345b29eddc579']
    if(arr.indexOf(id)!==-1){
        return true
    }else {
        return false
    }
}
export {
    jiemai
}